/**
 * Trade Entity Definition
 */
import { TradeRelationSchema } from "../schemas/relations";
import { defineEntity } from "./core";
import { getLazyBotConfigEntityDef } from "./lazy-refs";
export const TradeEntityDef = defineEntity({
    name: "trade",
    schema: TradeRelationSchema,
    relations: {
        bot_config: { type: "one", entity: getLazyBotConfigEntityDef },
    },
});
